import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Title from "../Co Components/Titles";
import homehero from '../assets/Images/homehero.png';
import TXD from '../assets/Images/partners/TXD.png';
import HOLOL from '../assets/Images/partners/holol.jpg';

import Rectangle from "../Co Components/RectangleCards";
import LineButton from "../Co Components/LineButton";
import cardImage from '../assets/Images/9.png';
import { useEffect } from 'react';
import PartnerCard from "../Co Components/PartnerCard";

const Resellers = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <Title className={''} header={"our"} body={"RESELLERS"} />
            <center>
                <p className={'fs-6 Poppins  w-100'}>
                            Our partnerships with trusted resellers allow us to bring you what you need to equip<br/> your organizations with the services they need across the globe.

                </p>
            </center>
            <div className={'container justify-content-center'}>
                <center>
                    <p className={'fs-6 Poppins  w-100'}>
                        Explore the Possibilities Across Our Reseller Partners
                    </p>
                </center>
                <div className={' mb-5 row justify-content-center '}>
                    <PartnerCard
                        to={'https://www.txdsystems.com/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={TXD}
                        Title={'TXD Systems Tech Xperts'}
                        address={'24 yousry fahmy, El-Sayed El-Merghany, Heliopolis, Cairo Governorate, Cairo, Egypt'}
                        email={'info@txdsystems.com'}
                        phone={'+0222913873'}
                    />
                    <PartnerCard
                        to={'https://hololtech.ly/'}
                        className={'mx-4 col-lg-4 mt-5'}
                        image={HOLOL}
                        Title={'Holol Technology'}
                        address={'Venice Street,' +
                            'Benghazi,' +
                            'Libya'}
                        email={'contact@hololtech.ly'}
                        phone={'+218 91 326 5777'}
                    />
                    {/*<PartnerCard*/}
                    {/*    className={'mx-4 col-lg-4 mt-5'}*/}
                    {/*    image={cardImage}*/}
                    {/*    address={'s 128, City Road, London, EC1V 2NX'}*/}
                    {/*    email={'sales@whiteguard.co.uk'}*/}
                    {/*    phone={'+44 1227391144'}*/}
                    {/*/>*/}
                    {/*<PartnerCard*/}
                    {/*    className={'mx-4 col-lg-4 mt-5'}*/}
                    {/*    image={cardImage}*/}
                    {/*    address={'s 128, City Road, London, EC1V 2NX'}*/}
                    {/*    email={'sales@whiteguard.co.uk'}*/}
                    {/*    phone={'+44 1227391144'}*/}
                    {/*/>*/}
                    {/*<PartnerCard*/}
                    {/*    className={'mx-4 col-lg-4 mt-5'}*/}
                    {/*    image={cardImage}*/}
                    {/*    address={'s 128, City Road, London, EC1V 2NX'}*/}
                    {/*    email={'sales@whiteguard.co.uk'}*/}
                    {/*    phone={'+44 1227391144'}*/}
                    {/*/>*/}
                    {/*<PartnerCard*/}
                    {/*    className={'mx-4 col-lg-4 mt-5'}*/}
                    {/*    image={cardImage}*/}
                    {/*    address={'s 128, City Road, London, EC1V 2NX'}*/}
                    {/*    email={'sales@whiteguard.co.uk'}*/}
                    {/*    phone={'+44 1227391144'}*/}
                    {/*/>*/}
                </div>
            </div>


            <Footer />
        </>
    );

}

export default Resellers;